import { useEffect, useState } from "react";
import MyUserSkeleton from "../../../components/skeleton/my/myUserSkeleton";
import { useNavigate } from "react-router-dom";
import { Divider, Flex } from "antd";
import { formatPhoneNumber, isLogin } from "../../../utils";
import { getMemberDataByToken, removeUser, logoutUser } from "../../../service";
import { TopBar } from "../../../widgets";
import { ReceiveMarketingSwitch, BasicInfoRow, ResignInfo } from "../../../shared";
import { ReactComponent as Info } from "../../../assets/images/icon/info.svg"
import { ReactComponent as ArrowRight } from "../../../assets/images/icon/arrow-right.svg"
import { ReactComponent as Kakao } from "../../../assets/images/icon/kakao.svg"
import { ReactComponent as Naver } from "../../../assets/images/icon/naver.svg"
import { ReactComponent as Apple } from "../../../assets/images/icon/apple.svg"
import NickNameCreateAndUpdate from "./ui/nickNameCreateAndUpdate";
import { useMyContext } from "../../../entities/context";

const Setting = () => {
    const [isInitLoading, setIsInitLoading] = useState<boolean>(true);
    const [memberData, setMemberData] = useState<IMember | undefined>(undefined);
    const [resignInfoModalStatus, setResignInfoModalStatus] = useState<boolean>(false);
    const navigate = useNavigate();
    const { deviceBuildVersion } = useMyContext();

    const logoutButtonClick = async () => {
        await logoutUser()
            .then((res) => { })
            .catch((error) => console.error("error: ", error))
            .finally(() => {
                removeUser();
                navigate("/");
            });
    }

    const initMemberDate = async () => {
        await getMemberDataByToken()
            .then((res) => {
                setMemberData(res.data);
            })
            .catch(() => removeUser())
            .finally(() => setIsInitLoading(false));
    }

    const getSocialIcon = (social: string) => {
        if (social === 'NAVER') {
            return <Naver width={16} height={16} style={{ padding: '4px' }} />
        }
        if (social === 'KAKAO') {
            return <Kakao width={16} height={16} style={{ padding: '4px' }} />
        }
        if (social === "APPLE") {
            return <Apple width={16} height={16} style={{ padding: '4px' }} />
        }
    }

    useEffect(() => {
        if (!isLogin()) {
            navigate("/login")
            return;
        }
        initMemberDate()

    }, [])

    return <>
        {(isInitLoading || !memberData) && <MyUserSkeleton />}
        {memberData && <>
            <TopBar title="설정" rightIcon={false} />
            <div style={{ marginTop: 24, padding: '0 20px' }}>
                <div className="title/t1">회원 정보</div>
                <div style={{ marginTop: 20 }}>
                    <BasicInfoRow styles={{ container: { paddingLeft: 0 } }} title="이름" content={<div style={{ display: 'flex', gap: '4px' }}>
                        <div>{memberData.name}</div>
                        {getSocialIcon(memberData.social)}
                    </div>} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow title="닉네임" content={<NickNameCreateAndUpdate propsNickName={memberData.nickName} propsRefetch={initMemberDate} />} styles={{ container: { paddingLeft: 0 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow title="연락처" content={formatPhoneNumber(memberData.mobile)} styles={{ container: { paddingLeft: 0 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow title="이메일" content={memberData.email} styles={{ container: { paddingLeft: 0 } }} />
                </div>
            </div>

            <div style={{ marginTop: 40, padding: '0 20px' }}>
                <div className="title/t1">약관 및 정책</div>
                <div style={{ marginTop: 20 }}>
                    <BasicInfoRow styles={{ container: { paddingLeft: 0 } }} onClick={() => navigate('/serviceUseTerm')}
                        title={<Flex style={{ alignItems: 'center' }} gap={4}>
                            <div className="body/b3">서비스 이용약관</div>
                        </Flex>} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow onClick={() => navigate('/personInfoPolicy')} title={'개인정보 처리방침'} styles={{ container: { paddingLeft: 0 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow onClick={() => navigate('/pointUsePolicy')} title={'포인트 이용기준'} styles={{ container: { paddingLeft: 0 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow onClick={() => navigate('/refundPolicy')} title={'파지티브호텔 요가 이용 약관'} styles={{ container: { paddingLeft: 0 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <BasicInfoRow onClick={() => navigate('/communityPolicy')} title={'커뮤니티 서비스 운영정책'} styles={{ container: { paddingLeft: 0 } }} />
                    <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                    <ReceiveMarketingSwitch memberId={memberData.id} title="마케팅 정보 수신 동의" setIsInitLoading={setIsInitLoading} />
                </div>
            </div>

            <Divider style={{ borderBlockStart: '6px solid var(--secondarys100)', margin: '20px 0' }} />
            <div style={{ padding: '0 20px 40px 20px' }}>
                <BasicInfoRow onClick={logoutButtonClick} title={'로그아웃'} styles={{ container: { paddingLeft: 0 } }} />
                <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                <Flex
                    className="body/b3"
                    style={{ padding: '14px 0 14px 0', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ color: 'var(--secondarys800)' }}>
                        <Flex style={{ alignItems: 'center' }} gap={4}>
                            <div className="body/b3">회원탈퇴</div>
                            <Info width={16} height={16} fill="#AEAEAE" style={{ cursor: "pointer" }} onClick={() => setResignInfoModalStatus(true)} />
                        </Flex>
                    </div>
                    <ArrowRight width={16} height={16} stroke="#737373" style={{ cursor: "pointer" }} onClick={() => navigate('/resign')} />
                </Flex>
                <Divider style={{ borderBlockStart: '1px solid var(--secondarys100)', margin: '0' }} />
                <BasicInfoRow title={'앱 정보'} styles={{ container: { paddingLeft: 0 } }} content={<div className="body/b3 secondary/s500">{deviceBuildVersion}</div>} iconRender={<></>} />
            </div>
            <ResignInfo resignInfoModalStatus={resignInfoModalStatus} setResignInfoModalStatus={setResignInfoModalStatus} />
        </>}
    </>
}

export { Setting }